<template>
  <MDBRow class="pb-5 pt-1">
    <MDBCol lg="6" cols="12">
      <div class="textBox textBox--small column-order">
        <h4>
          {{ $t("trainings.summary.congratulations") }}
          {{ training.title[storedLocale] }}!
        </h4>
        <div>
          <div>{{ $t("trainings.summary.participation", { name: training.title[storedLocale] }) }} </div>
          <div>
            {{ $t("trainings.summary.certificate") }}
          </div>
        </div>
        <div class="py-2">
          <button type="submit" class="btn btn-danger text-uppercase" @click="$emit('downloadCertificate')">
            {{ $t("trainings.summary.send") }}
          </button>
        </div>
      </div>
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { MDBCol, MDBRow } from "mdb-vue-ui-kit";
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  training: Object,
});
props;

defineEmits(["storePoints", "downloadCertificate"]);
const storedLocale = computed(() => store.getters.getCurrentLocale);
</script>
